<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-xl-5 b-center bg-size p-0" :style="{ backgroundImage: 'url('+ require('../../assets/images/login/3.jpg') +')' }"
          style="background-size: cover; background-position: center center; display: block;">
          <img
            class="bg-img-cover bg-center"
            src="../../assets/images/login/3.jpg"
            alt="looginpage"
            style="display: none;"
          />
        </div>
        <div class="col-xl-7 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img
                    class="img-fluid for-light"
                    src="../../assets/images/logo/logo.png"
                    alt="looginpage"
                  />
                  <img
                    class="img-fluid for-dark"
                    src="../../assets/images/logo/logo_dark.png"
                    alt="looginpage"
                  />
                </a>
              </div>
              


              <div class="login-main login-form-card">
                <b-alert variant="danger" :show="!error_message==''" class="alert alert-warning inverse alert-dismissible">
                    <i class="icon-bell"></i>
                    <p>{{error_message}}</p>
                </b-alert>
                <b-alert variant="success" :show="successed" class="alert alert-warning inverse alert-dismissible">
                    <i class="icon-bell"></i>
                    <p>register is successfully, please verify your email</p>
                </b-alert>
                <form class="theme-form" @submit.prevent="handleSubmit">
                  <h4>Create your account</h4>
                  <p>Enter your personal details to create account</p>
                  <div class="form-group">
                    <label class="col-form-label pt-0">Your Name</label>
                    <div class="form-row">
                      <div class="col-6">
                        <input
                          class="form-control"
                          type="text"
                          required=""
                          placeholder="First name"
                          v-model="firstname"
                        />
                      </div>
                      <div class="col-6">
                        <input
                          class="form-control"
                          type="text"
                          required=""
                          placeholder="Last name"
                          v-model="lastname"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Phone</label>
                    <input
                      class="form-control"
                      type="text"
                      required=""
                      placeholder="phone number"
                      v-model="phone"
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input
                      class="form-control"
                      type="email"
                      required=""
                      placeholder="Test@gmail.com"
                      v-model="email"
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <input
                      class="form-control"
                      :type="type"
                      name="login[password]"
                      required=""
                      placeholder="*********"
                      v-model="password"
                    />
                    <div class="show-hide" @click="showPassword"><span class="show"></span></div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox" />
                      <label class="text-muted" for="checkbox1"
                        >Agree with<a class="ml-2" href="#"
                          >Privacy Policy</a
                        ></label
                      >
                    </div>
                    <button class="btn btn-primary btn-block" type="submit">
                      Create Account
                    </button>
                  </div>
                  <p class="mt-4 mb-0">
                    Already have an account?
                    <router-link class="ml-2" tag="a" to="/login">
                      Login
                    </router-link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { authService } from './../../_services';
  
  export default {
    name: 'register',
    data() {
      return {
        type: 'password',
        email: '',
        password: '',
        firstname:'',
        lastname:'',
        phone:'',
        submitted: false,
        error_message:'',
        successed:false
      };
    },
    computed: {
      // JWT authentication
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created() {
      // reset login status for JWT
      this.$store.dispatch('authentication/logout');
    },
    methods: {
      // show/hide password
      showPassword: function() {
        if (this.type === 'password') {
          this.type = 'text';
        } else {
          this.type = 'password';
        }
      },
      // signUp
      handleSubmit: function() {
        this.submitted = true;
        this.error_message = '';
        var self = this;
        const { email,password,firstname,lastname,phone } = this;
        //console.log(email,username,password,firstname,lastname,phone);
        authService.register(email,password,firstname,lastname,phone).then((response) => {
          response.text().then(text => {
            const data = text && JSON.parse(text);
            if (!response.ok) {
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            } else {
              self.successed = true;
              this.$notify({ text: 'register is successfully',type: 'success' });
              this.$router.push('/verify_email?email='+self.email);
            }
          }).catch( error => {
            self.error_message = error;
          });
        });
      },
    },
  };
</script>